<template><!-- svgo-optimised -->
<svg class="icon icon__plus" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M10.862 10.97H8V12.68H10.862V15.65H12.77V12.68H15.632V10.97H12.77V8H10.862V10.97Z" /></svg>
</template>